// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { AiAgentTaskContextItem, AiAgentTaskDomElementIn, AiChatCommitIdOffset, AiChatMessage, Batch, BatchInfo, ExecCommandResult, ExecCommandResultUpdated, MessagesSorting, TID, TypingEventDTO, UAiChatEvent, UTaskCheckpointCheckoutResult } from "./TypeDefinitions.ts"

export interface AiChatApi {
  archivedMessages(taskId: TID, blockMessageIds: TID[], batchInfo: BatchInfo, sorting: MessagesSorting): Promise<Batch<AiChatMessage>>

  /** @deprecated Left for compatibility with Fleet */
  archivedMessages2(blockMessageIds: TID[], batchInfo: BatchInfo, sorting: MessagesSorting): Promise<Batch<AiChatMessage>>

  commandOutputUpdates(taskId: TID): Promise<Observable<ExecCommandResultUpdated>>

  editMessage(messageId: TID, text: string, context: AiAgentTaskContextItem[], attachments: TID[], domElements: AiAgentTaskDomElementIn[], dropNewerVersions: boolean | null): Promise<UTaskCheckpointCheckoutResult>

  getExecCommandResult(execResultId: TID, skipStdOut: number, skipStdErr: number): Promise<ExecCommandResult>

  getOffsetByCommitId(taskId: TID, commitId: string): Promise<AiChatCommitIdOffset | null>

  getSlackNotificationsEnabled(): Promise<boolean>

  message(messageId: TID): Promise<AiChatMessage>

  messageUpdates(taskId: TID): Promise<Observable<UAiChatEvent>>

  messages(taskId: TID, batchInfo: BatchInfo, sorting: MessagesSorting): Promise<Batch<AiChatMessage>>

  read(messageId: TID): Promise<void>

  resetSlackToken(): Promise<void>

  sendMessage(taskId: TID, text: string, context: AiAgentTaskContextItem[], attachments: TID[], domElements: AiAgentTaskDomElementIn[], forceCoding: boolean | null): Promise<TID>

  sendTypingEvent(taskId: TID, stop: boolean): Promise<void>

  startSlackUserForNotificationsOAuthFlow(backUrl: string): Promise<string>

  subscribeToTypingEvents(taskId: TID): Promise<Observable<TypingEventDTO>>
}

export class AiChatApiClient implements AiChatApi {
  constructor(private service: ApiService) {}

  async archivedMessages(taskId: TID, blockMessageIds: TID[], batchInfo: BatchInfo, sorting: MessagesSorting): Promise<Batch<AiChatMessage>> {
    return getResult(await this.service.rpc<Batch<AiChatMessage>, never>("AiChatApi/archivedMessages", {
      taskId: taskId,
      blockMessageIds: blockMessageIds,
      batchInfo: batchInfo,
      sorting: sorting,
    }))
  }

  /** @deprecated Left for compatibility with Fleet */
  async archivedMessages2(blockMessageIds: TID[], batchInfo: BatchInfo, sorting: MessagesSorting): Promise<Batch<AiChatMessage>> {
    return getResult(await this.service.rpc<Batch<AiChatMessage>, never>("AiChatApi/archivedMessages2", {
      blockMessageIds: blockMessageIds,
      batchInfo: batchInfo,
      sorting: sorting,
    }))
  }

  async commandOutputUpdates(taskId: TID): Promise<Observable<ExecCommandResultUpdated>> {
    return getUpdates(await this.service.rpc<void, ExecCommandResultUpdated>("flux/AiChatApi/commandOutputUpdates", {
      taskId: taskId,
    }))
  }

  async editMessage(messageId: TID, text: string, context: AiAgentTaskContextItem[], attachments: TID[], domElements: AiAgentTaskDomElementIn[], dropNewerVersions: boolean | null): Promise<UTaskCheckpointCheckoutResult> {
    return getResult(await this.service.rpc<UTaskCheckpointCheckoutResult, never>("AiChatApi/editMessage", {
      messageId: messageId,
      text: text,
      context: context,
      attachments: attachments,
      domElements: domElements,
      dropNewerVersions: dropNewerVersions,
    }))
  }

  async getExecCommandResult(execResultId: TID, skipStdOut: number, skipStdErr: number): Promise<ExecCommandResult> {
    return getResult(await this.service.rpc<ExecCommandResult, never>("AiChatApi/getExecCommandResult", {
      execResultId: execResultId,
      skipStdOut: skipStdOut,
      skipStdErr: skipStdErr,
    }))
  }

  async getOffsetByCommitId(taskId: TID, commitId: string): Promise<AiChatCommitIdOffset | null> {
    return getResult(await this.service.rpc<AiChatCommitIdOffset | null, never>("AiChatApi/getOffsetByCommitId", {
      taskId: taskId,
      commitId: commitId,
    }))
  }

  async getSlackNotificationsEnabled(): Promise<boolean> {
    return getResult(await this.service.rpc<boolean, never>("AiChatApi/getSlackNotificationsEnabled", {
    }))
  }

  async message(messageId: TID): Promise<AiChatMessage> {
    return getResult(await this.service.rpc<AiChatMessage, never>("AiChatApi/message", {
      messageId: messageId,
    }))
  }

  async messageUpdates(taskId: TID): Promise<Observable<UAiChatEvent>> {
    return getUpdates(await this.service.rpc<void, UAiChatEvent>("flux/AiChatApi/messageUpdates", {
      taskId: taskId,
    }))
  }

  async messages(taskId: TID, batchInfo: BatchInfo, sorting: MessagesSorting): Promise<Batch<AiChatMessage>> {
    return getResult(await this.service.rpc<Batch<AiChatMessage>, never>("AiChatApi/messages", {
      taskId: taskId,
      batchInfo: batchInfo,
      sorting: sorting,
    }))
  }

  async read(messageId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiChatApi/read", {
      messageId: messageId,
    }))
  }

  async resetSlackToken(): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiChatApi/resetSlackToken", {
    }))
  }

  async sendMessage(taskId: TID, text: string, context: AiAgentTaskContextItem[], attachments: TID[], domElements: AiAgentTaskDomElementIn[], forceCoding: boolean | null): Promise<TID> {
    return getResult(await this.service.rpc<TID, never>("AiChatApi/sendMessage", {
      taskId: taskId,
      text: text,
      context: context,
      attachments: attachments,
      domElements: domElements,
      forceCoding: forceCoding,
    }))
  }

  async sendTypingEvent(taskId: TID, stop: boolean): Promise<void> {
    return getResult(await this.service.rpc<void, never>("AiChatApi/sendTypingEvent", {
      taskId: taskId,
      stop: stop,
    }))
  }

  async startSlackUserForNotificationsOAuthFlow(backUrl: string): Promise<string> {
    return getResult(await this.service.rpc<string, never>("AiChatApi/startSlackUserForNotificationsOAuthFlow", {
      backUrl: backUrl,
    }))
  }

  async subscribeToTypingEvents(taskId: TID): Promise<Observable<TypingEventDTO>> {
    return getUpdates(await this.service.rpc<void, TypingEventDTO>("flux/AiChatApi/subscribeToTypingEvents", {
      taskId: taskId,
    }))
  }

}

